var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumnUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_12519_21431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 0C4.49341 0 0 4.49417 0 10C0 15.5066 4.49417 20 10 20C15.5066 20 20 15.5058 20 10C20 4.49341 15.5058 0 10 0ZM10 18.8281C5.13214 18.8281 1.17188 14.8679 1.17188 10C1.17188 5.13214 5.13214 1.17188 10 1.17188C14.8679 1.17188 18.8281 5.13214 18.8281 10C18.8281 14.8679 14.8679 18.8281 10 18.8281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.55469 7.07031V12.9297H6.28906L11.7578 17.0312V2.96875L6.28906 7.07031H3.55469ZM5.89844 11.7578H4.72656V8.24219H5.89844V11.7578ZM10.5859 14.6875L7.07031 12.0508V7.94922L10.5859 5.3125V14.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.8594 9.41406V7.65625H14.6875V9.41406H12.9297V10.5859H14.6875V12.3438H15.8594V10.5859H17.6172V9.41406H15.8594Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12519_21431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumnUp);
export default __webpack_public_path__ + "static/media/volumn_up.df13961707e5dba0f71f1fc1a50227d4.svg";
export { ForwardRef as ReactComponent };